var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Fluid-ok",
    viewBox: "0 0 745.04 215.62",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#20274a;}.cls-2{fill:#f9c900;}.cls-3{fill:#fff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M91.62,48.05h-76V109H61.16A14.64,14.64,0,0,1,75.8,123.62H15.58v72.49H0V33.42H91.62Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M117.82,196.11V25.86h15.11V196.11Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M252.18,85.84h15.11V196.11H252.18V176.75c-6.61,15.58-24.56,22.19-38.26,22.19-26.68,0-44.86-18.41-44.63-48.87V85.84h15.12v64c0,21.25,13.22,34.71,31.17,34.71,17.47,0,36.36-10.39,36.6-37.07Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M305.06,196.11V85.84h0A15.11,15.11,0,0,1,320.17,101v95.16Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M450.28,25.86h15.34V196.11H450.28V174.62c-8.27,15.11-25.51,24.32-43.92,24.32-30.7,0-56-24.56-56-58.08s25-57.86,56-57.86C425,83,442,92,450.28,107.09Zm0,115.47c0-26.68-20.78-43.92-42.74-43.92-23.14,0-42,18.89-42,43.21,0,24.56,18.9,43.92,42,43.92C430.44,184.54,450.28,166.83,450.28,141.33Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M538.15,0H744.27a0,0,0,0,1,0,0V185.62a30,30,0,0,1-30,30H508.15a0,0,0,0,1,0,0V30a30,30,0,0,1,30-30Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M556,24.91h16.61a0,0,0,0,1,0,0v190.7a0,0,0,0,1,0,0H543.76a0,0,0,0,1,0,0V37.11A12.2,12.2,0,0,1,556,24.91Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M744.27,24.91H598.07v29h46.48v129a12.27,12.27,0,0,0,12.27,12.27h16.7V53.89h70.75Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M300.47,46.62c3.26-7.59,7-14.72,12.24-15.59,6.86-.16,10.63,6.29,12.72,15,1.4,7.39-6.1,12.27-13.84,13.59C304.22,60.92,297.16,54.35,300.47,46.62Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.a2c1840ea4d03a5b1d5c8359ee054e62.svg";
export { ForwardRef as ReactComponent };